<img [src]="src" alt="">